import FullScreenLoader from "../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AgentSidebar from "./Commun/AgentSidebar";
import { AgentHeader } from "./Commun/AgentHeader";
import { agentPropertylist, agentPreBooking, SaveAgentPreBookingRoomAdd, getAgentRoomRateSelect } from "../Services/Service";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgentRoomRestriction } from "../Redux/Slices/agentRoomRestriction";

export const AgentBooking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roomRestrictions = useSelector((state) => state.agentRoomRestriction.byRoomID);
  const [agentproperty, setAgentproperty] = useState([]);
  const [selectedPropertyID, setSelectedPropertyID] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [totalRooms, setTotalRooms] = useState(1);
  const [loading, setLoading] = useState(false);

  const [roomDetails, setRoomDetails] = useState([]);
  const [selectedRatePlans, setSelectedRatePlans] = useState({});
  const [selectedMealPlans, setSelectedMealPlans] = useState({});
  const [roomCounts, setRoomCounts] = useState({});
  const [roomOccupancy, setRoomOccupancy] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [roomRates, setRoomRates] = useState({});

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    setCheckInDate(today.toISOString().split("T")[0]);
    setCheckOutDate(tomorrow.toISOString().split("T")[0]);
  }, []);

  useEffect(() => {
    const fetchProperties = async () => {
      setLoading(true);
      try {
        const res = await agentPropertylist();
        const propsArr = Array.isArray(res) ? res : [];
        setAgentproperty(propsArr);
        if (propsArr.length > 0 && !selectedPropertyID) {
          setSelectedPropertyID(propsArr[0].PropertyID ?? propsArr[0].id);
        }
      } catch (err) {
        console.error("Error fetching properties", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
  }, [selectedPropertyID]);

  const handleCheckInChange = (date) => {
    setCheckInDate(date);
    const next = new Date(date);
    next.setDate(next.getDate() + 1);
    setCheckOutDate(next.toISOString().split("T")[0]);
  };

  const formatAPIDate = (yyyyMmDd) => (yyyyMmDd ? `${yyyyMmDd}` : "");

  const handleSearch = async () => {
    if (!selectedPropertyID || !checkInDate || !checkOutDate) {
      swal("Please select property and dates", { icon: "warning" });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        PropertyID: selectedPropertyID,
        CheckIn: formatAPIDate(checkInDate),
        CheckOut: formatAPIDate(checkOutDate),
        TotalRoom: totalRooms,
      };

      const res = await agentPreBooking(payload);
      // console.log(res)
      const rooms = res?.RatePlan || [];

      const parsedRooms = rooms.map((r) => ({
        ...r,
        RatePlanParsed: r.RatePlan ? JSON.parse(r.RatePlan) : [],
      }));

      setRoomDetails(parsedRooms);
      setRoomCounts({});
      setSelectedRatePlans({});
      setSelectedMealPlans({});
      setRoomOccupancy({});

      const preBooking = res?.RoomDetails?.[0];
      if (preBooking?.PreBookingToken) {
        localStorage.setItem("AgentPreBookingToken", preBooking.PreBookingToken);
        localStorage.setItem("AgentCheckIn", preBooking.Checkin);
        localStorage.setItem("AgentCheckOut", preBooking.checkout);
        localStorage.setItem("AgentPropertyID", preBooking.Property);
      }

      const companyDetails = res?.CompanyDetails?.[0];
      if (companyDetails) {
        localStorage.setItem("AgentMarketSegment", companyDetails.MarketSegment);
        localStorage.setItem("AgentBusinessSource", companyDetails.BusinessSource);
        localStorage.setItem("AgentGuaranteeCodes", companyDetails.guaranteeCodes);
        localStorage.setItem("AgentCompany", companyDetails.CompanyName);
        localStorage.setItem("AgentGst", companyDetails.Gst);
        localStorage.setItem("AgentAddress", companyDetails.Address);
      }

    } catch (err) {
      const message = err?.response?.data?.Message;

      if (message) {
        swal(message, {
          icon: "warning",
          buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
        });
      }

      console.error("Error fetching prebooking", err);
      setRoomDetails([]);
    } finally {
      setLoading(false);
    }
  };



  const handleRatePlanChange = (roomId, rateCode, room) => {
    const ratePlan = {
      Code: rateCode,
      Name: rateCode,
    };

    setSelectedRatePlans((prev) => ({
      ...prev,
      [roomId]: ratePlan,
    }));

    setSelectedMealPlans((prev) => ({
      ...prev,
      [roomId]: null,
    }));
  };

  const handleMealPlanChange = (roomID, mealCode, room) => {
    const mealPlans = room.MealPlan ? JSON.parse(room.MealPlan) : [];
    const selectedMeal = mealPlans.find((m) => m.MealPlanCode === mealCode);

    setSelectedMealPlans((prev) => ({
      ...prev,
      [roomID]: selectedMeal,
    }));

    // meal plan badalte hi purani quantity/rate selection clear kar do
    setRoomCounts((prev) => {
      const updated = { ...prev };
      delete updated[roomID];
      return updated;
    });

    dispatch(
      fetchAgentRoomRestriction({
        roomID,
        PropertyID: selectedPropertyID,
        CheckInDate: checkInDate,
        CheckOutDate: checkOutDate,
        RateCode: selectedMeal.RatePlanCode, // meal plan ka RatePlanCode
        RoomCode: room.RoomCode,             // room ka RoomCode
      })
    );
  };

  const handleIncrement = async (roomID) => {
    const room = roomDetails.find(r => r.RoomID === roomID);
    const roomAvailable = room?.count || 0;
    const currentRoomCount = roomCounts[roomID] || 0;

    if (currentRoomCount < roomAvailable && currentRoomCount < totalRooms) {
      setRoomCounts(prev => ({ ...prev, [roomID]: currentRoomCount + 1 }));

      // API call karo rate fetch karne ke liye
      const ratePlanCode = selectedMealPlans[roomID]?.RateCodeID || "";
      const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;
      const rateCodeID = ratePlanCode || 0;
      const rateTypeCode = "Travel Agent";
      const rateTypeID = 0;
      const PropertyID = selectedPropertyID;

      try {
        const response = await getAgentRoomRateSelect(
          rateCodeID,
          mealPlanID,
          roomID,         // roomTypeID
          rateTypeCode,
          rateTypeID,
          PropertyID,
          checkInDate
        );

        const rateData = response?.[0];
        if (rateData) {
          // roomRates mein store karo
          setRoomRates(prev => ({
            ...prev,
            [roomID]: rateData,
          }));

          // _RCM mein bhi inject karo taaki BaseRate td mein show ho
          setSelectedMealPlans(prev => ({
            ...prev,
            [roomID]: {
              ...prev[roomID],
              _RCM: [rateData],
            }
          }));
        }
      } catch (error) {
        console.log("Rate fetch error on select:", error);
      }
    }
  };

  const handleDecrement = (roomID) => {
    setRoomCounts(prev => {
      const curr = prev[roomID] || 0;
      if (curr <= 1) {
        const updated = { ...prev };
        delete updated[roomID];
        return updated;
      }
      return { ...prev, [roomID]: curr - 1 };
    });
  };

  const updateOccupancy = async (roomID, index, type, action) => {
    const key = `${roomID}-${index}`;

    // Pehle new value calculate karo
    const current = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };
    const min = type === "adults" ? 1 : 0; // adults min 1, baaki 0
    const newValue = Math.max(min, current[type] + (action === "increment" ? 1 : -1));

    // State update karo
    const updatedOccupancy = {
      ...current,
      [type]: newValue,
    };

    setRoomOccupancy(prev => ({
      ...prev,
      [key]: updatedOccupancy,
    }));

    // Rate API sirf adults change par call karo
    if (type === "adults") {
      const ratePlanCode = selectedMealPlans[roomID]?.RateCodeID || "";
      const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;
      const rateTypeCode = "Travel Agent";
      const rateTypeID = 0;
      const rateCodeID = ratePlanCode || 0;
      const roomTypeID = roomID;
      const PropertyID = selectedPropertyID;

      try {
        const response = await getAgentRoomRateSelect(
          rateCodeID,
          mealPlanID,
          roomTypeID,
          rateTypeCode,
          rateTypeID,
          PropertyID,
          checkInDate
        );

        // API response roomRates mein store karo (pure room ke liye, index-wise nahi)
        const rateData = response?.[0];
        if (rateData) {
          setRoomRates(prev => ({
            ...prev,
            [roomID]: rateData, // roomID se store karo, key nahi
          }));
        }
      } catch (error) {
        console.log("Rate API error", error);
      }
    }
  };

  const totalSelectedCount = Object.values(roomCounts).reduce((s, c) => s + c, 0);

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const calculateRoomPrice = (roomID, index) => {
    const key = `${roomID}-${index}`;
    const occupancy = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };

    // Pehle API se aayi rate use karo, fallback mein meal plan ki rate
    const apiRate = roomRates[roomID]; // roomID se lo
    const meal = selectedMealPlans[roomID]?._RCM?.[0] || {};

    const baseRate = apiRate?.BaseRate ?? meal.BaseRate ?? 0;
    const doubleRate = apiRate?.DoubleRate ?? meal.DoubleRate ?? 0;
    const tripleRate = apiRate?.TripleRate ?? meal.TripleRate ?? 0;
    const extraAdultRate = apiRate?.ExtraAdultRate ?? meal.ExtraAdultRate ?? 0;
    const extraChildRate = apiRate?.ExtraChildRate ?? meal.ExtraChildRate ?? 0;
    const extraBedRate = apiRate?.ExtraBedCharges ?? meal.ExtraBedCharges ?? 0;

    const { adults, children, extraBed } = occupancy;

    // Adult rate logic
    let totalRate = 0;
    if (adults === 1) totalRate = baseRate;
    else if (adults === 2) totalRate = doubleRate;
    else if (adults === 3) totalRate = tripleRate;
    else if (adults > 3) {
      // 4th adult se aage: tripleRate + (extra adults * extraAdultRate)
      totalRate = tripleRate + (adults - 3) * extraAdultRate;
    }

    // Children charges
    totalRate += children * extraChildRate;

    // Extra bed charges
    totalRate += extraBed * extraBedRate;

    return totalRate;
  };

  const handleContinueBooking = async () => {
    setLoading(true);
    const preBookingToken = localStorage.getItem("AgentPreBookingToken");

    try {
      const roomsToBook = roomDetails.filter(room => roomCounts[room.RoomID] > 0);

      if (roomsToBook.length === 0) {
        swal("Please select at least one room with rate plan.", {
          icon: "warning",
          buttons: { confirm: { text: "OK", className: "btn btn-warning" } },
        });
        setLoading(false);
        return;
      }

      for (const room of roomsToBook) {
        const quantity = roomCounts[room.RoomID];
        const mealPlan = selectedMealPlans[room.RoomID];

        // Selected meal plan ka pura object lo MealPlan array se
        const mealPlanList = room.MealPlan ? JSON.parse(room.MealPlan) : [];
        const selectedMealObj = mealPlanList.find(
          mp => mp.MealPlanCode === mealPlan?.MealPlanCode
        );

        // RatePlanCode aur MealPlanID selected meal se lo
        const ratePlanCode = selectedMealObj?.RatePlanCode || "";
        const mealPlanCode = selectedMealObj?.MealPlanCode || "";

        for (let i = 0; i < quantity; i++) {
          const key = `${room.RoomID}-${i}`;
          const occupancy = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };

          // Extra bed amount - roomRates se lo
          const rateData = roomRates[room.RoomID];
          const extraBedCharges = rateData?.ExtraBedCharges || selectedMealObj?.ExtraBedCharges || 0;

          // 👇 Room price nikalo aur uske hisaab se tax % decide karo
          const roomPrice = calculateRoomPrice(room.RoomID, i);
          const taxPercent = roomPrice < 7500 ? 5 : 18;
          const taxRate = (roomPrice * taxPercent) / 100;
          const netAmount = roomPrice + taxRate;

          // console.log(taxPercent, taxRate, netAmount);

          const formData = new FormData();
          formData.append("ID", "0");
          formData.append("PreBookingToken", preBookingToken);
          formData.append("RoomID", room.RoomID);
          formData.append("RatePlanID", ratePlanCode);        // ← RatePlanCode
          formData.append("MealPlanID", mealPlanCode);          // ← MealPlanID
          formData.append("TotalRoom", 1);
          formData.append("RoomRate", roomPrice);
          formData.append("ExtraBed", occupancy.extraBed);
          formData.append("ExtraBedAmount", occupancy.extraBed * extraBedCharges);
          formData.append("Adults", occupancy.adults);
          formData.append("Child", occupancy.children);
          formData.append("Tax", taxPercent);
          formData.append("TaxRate", taxRate);
          formData.append("NetAmount", netAmount);

          const result = await SaveAgentPreBookingRoomAdd(formData);

          if (!result?.PreBookingToken && result?.Message) {
            swal(result.Message, {
              icon: "error",
              buttons: { confirm: { text: "OK", className: "btn btn-danger" } },
            });
            setLoading(false);
            return;
          }
        }
      }

      swal("Rooms successfully added!", {
        icon: "success",
        buttons: { confirm: { text: "OK", className: "btn btn-success" } },
      }).then(() => navigate("/Agent/BookingConfirm"));

    } catch (err) {
      swal("Something went wrong. Please try again.", {
        icon: "error",
        buttons: { confirm: { text: "OK", className: "btn btn-danger" } },
      });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <style>{`
       .label-set{
             top: -9px;
              padding-inline: 8px;
              font-weight: bold;
              background: #ffffff;
              left: 23px;
       }
    `}</style>
      {loading && <FullScreenLoader />}
      <div className="wrapper">
        <AgentSidebar />
        <div className="main-panel">
          <AgentHeader />
          <div className="container">
            <div className="page-inner">
              {/* Booking Form */}
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header"><div className="card-title">Agent Booking</div></div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <select className="form-select form-control" value={selectedPropertyID} onChange={e => setSelectedPropertyID(e.target.value)}>
                            <option value="">Select Property</option>
                            {agentproperty.map(p => <option key={p.PropertyID ?? p.id} value={p.PropertyID ?? p.id}>{p.PropertyName ?? p.name}</option>)}
                          </select>
                        </div>
                        <div className="col-md-2 position-relative"><label className="position-absolute label-set" >Form</label><input type="date" className="form-control" value={checkInDate} onChange={e => handleCheckInChange(e.target.value)} /></div>
                        <div className="col-md-2 position-relative"><label className="position-absolute label-set">To</label><input type="date" className="form-control" value={checkOutDate} onChange={e => setCheckOutDate(e.target.value)} min={checkInDate} /></div>
                        <div className="col-md-2 position-relative">
                          <label className="position-absolute label-set">Total Room</label>
                          <select className="form-select form-control" value={totalRooms} onChange={e => setTotalRooms(Number(e.target.value))}>
                            {Array.from(
                              { length: selectedPropertyID ? (agentproperty.find(p => (p.PropertyID ?? p.id) === selectedPropertyID)?.MaxRoomBook || 1) : 1 },
                              (_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                              )
                            )}
                          </select>
                        </div>
                        <div className="col-md-1 text-end"><button className="btn btn-primary" onClick={handleSearch}>Search</button></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Room List */}
              {roomDetails.length > 0 &&
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="card-title mb-0">Room List</h4>
                      </div>
                      <div className="card-body">
                        <table className="table text-center">
                          <thead>
                            <tr>
                              <th className="text-start">Room Type</th>
                              <th style={{ width: "200px" }}>Meal Plan</th>
                              <th>Quantity</th>
                              <th>Per Room Rate</th>
                            </tr>
                          </thead>
                          <tbody>
                            {roomDetails.map(r => {
                              const selectedRate = selectedRatePlans[r.RoomID];
                              const selectedMeal = selectedMealPlans[r.RoomID];
                              const roomQty = roomCounts[r.RoomID] || 0;
                              const isRoomLoading = roomRestrictions[r.RoomID]?.loading;
                              const isRoomUnavailable = r.count === 0 || roomRestrictions[r.RoomID]?.restricted;

                              // 👇 common JSX messages
                              const loadingMsg = (
                                <span className="text-muted fw-bold">
                                  Loading...
                                </span>
                              );

                              const noRoomAvailableMsg = (
                                <span className="text-danger fw-bold">
                                  No Room Available
                                </span>
                              );

                              return (
                                <tr key={r.RoomID}>
                                  <td className="text-start">{r.RoomName}</td>

                                  {/* Meal Plan */}
                                  <td>
                                    {r.count > 0 && (
                                      <select
                                        className="form-select"
                                        value={selectedMeal?.MealPlanCode || ""}
                                        onChange={(e) =>
                                          handleMealPlanChange(r.RoomID, e.target.value, r)
                                        }
                                      >
                                        <option value="">Select Meal Plan</option>

                                        {(r.MealPlan ? JSON.parse(r.MealPlan) : []).map((mp, index) => (
                                          <option key={index} value={mp.MealPlanCode}>
                                            {mp.MealPlanName}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  </td>

                                  {/* Quantity */}
                                  <td>
                                    {isRoomLoading ? (
                                      loadingMsg
                                    ) : isRoomUnavailable ? (
                                      noRoomAvailableMsg
                                    ) : selectedMeal ? (
                                      roomQty ? (
                                        <div className="hstack gap-2 justify-content-center">
                                          <button
                                            onClick={() => handleDecrement(r.RoomID)}
                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                          >
                                            <i className="fas fa-minus"></i>
                                          </button>
                                          <span>{roomQty}</span>
                                          <button
                                            onClick={() => handleIncrement(r.RoomID)}
                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                          >
                                            <i className="fas fa-plus"></i>
                                          </button>
                                        </div>
                                      ) : (
                                        <button
                                          className="btn btn-sm btn-black"
                                          onClick={() => handleIncrement(r.RoomID)}
                                        >
                                          Select
                                        </button>
                                      )
                                    ) : null}
                                  </td>

                                  {/* Per Room Rate */}
                                  <td>
                                    {isRoomLoading
                                      ? loadingMsg
                                      : isRoomUnavailable
                                        ? noRoomAvailableMsg
                                        : r.count > 0 && (selectedMeal ? selectedMeal._RCM?.[0]?.BaseRate ?? 0 : "")}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>}

              {/* Continue Booking Button */}
              {totalSelectedCount > 0 && <div className="bg-light border-top text-end px-4 py-3" style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', zIndex: 999 }}>
                <button className="btn btn-black" onClick={() => setShowPopup(true)}>Continue ({totalSelectedCount})</button>
              </div>}

              {/* Popup Modal */}
              {showPopup && (
                <div
                  className="modal d-block"
                  tabIndex="-1"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1050,
                    padding: "18px",
                  }}
                >
                  <div
                    className="modal-dialog"
                    style={{
                      maxWidth: "600px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="modal-content"
                      style={{
                        borderRadius: "10px",
                        overflow: "hidden",
                      }}
                    >
                      <div className="modal-header">
                        <h5 className="modal-title">Selected Rooms</h5>
                      </div>

                      <div className="modal-body p-3">
                        <div className="d-flex justify-content-between mb-3">
                          <div><strong>From:</strong> {formatDateToDDMMYYYY(checkInDate)}</div>
                          <div><strong>To:</strong> {formatDateToDDMMYYYY(checkOutDate)}</div>
                        </div>

                        {roomDetails
                          .filter(room => roomCounts[room.RoomID])
                          .flatMap((room) => {
                            const quantity = roomCounts[room.RoomID] || 0;

                            return Array.from({ length: quantity }, (_, i) => {
                              const key = `${room.RoomID}-${i}`;
                              const occupancy = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };

                              return (
                                <div key={key} className="bg-light p-3 rounded mb-3 position-relative">
                                  <div className="d-flex justify-content-between mb-2">
                                    <strong>{room.RoomName}</strong>
                                    <div>
                                      <span>Meal Plan: <strong className="text-danger">{selectedMealPlans[room.RoomID]?.MealPlanName}</strong></span>
                                    </div>
                                  </div>

                                  {/* Occupancy Controls */}
                                  <div className="row">
                                    <div className="col-md-2">
                                      <label className="fw-bold">Adults</label>
                                      <div className="hstack gap-2 mb-2">
                                        <button onClick={() => updateOccupancy(room.RoomID, i, 'adults', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                          <i className="fas fa-minus"></i>
                                        </button>
                                        <span>{occupancy.adults}</span>
                                        <button onClick={() => updateOccupancy(room.RoomID, i, 'adults', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                          <i className="fas fa-plus"></i>
                                        </button>
                                      </div>
                                    </div>

                                    <div className="col-md-2">
                                      <label className="fw-bold">Children</label>
                                      <div className="hstack gap-2 mb-2">
                                        <button onClick={() => updateOccupancy(room.RoomID, i, 'children', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                          <i className="fas fa-minus"></i>
                                        </button>
                                        <span>{occupancy.children}</span>
                                        <button onClick={() => updateOccupancy(room.RoomID, i, 'children', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                          <i className="fas fa-plus"></i>
                                        </button>
                                      </div>
                                    </div>

                                    <div className="col-md-3">
                                      <label className="fw-bold">Extra Bed</label>
                                      <div className="hstack gap-2 mb-2">
                                        <button onClick={() => updateOccupancy(room.RoomID, i, 'extraBed', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                          <i className="fas fa-minus"></i>
                                        </button>
                                        <span>{occupancy.extraBed}</span>
                                        <button onClick={() => updateOccupancy(room.RoomID, i, 'extraBed', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                          <i className="fas fa-plus"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="fw-bold fs-5 position-absolute" style={{ bottom: "10px", right: "15px" }}>
                                    ₹ {calculateRoomPrice(room.RoomID, i)}
                                  </div>
                                </div>
                              );
                            });
                          })}
                      </div>

                      <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={() => setShowPopup(false)}>Close</button>
                        <button type="button" className="btn btn-primary" onClick={handleContinueBooking}>Continue</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};